import React from 'react'
import { Select } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const LIMIT_TYPES = ['budget_limit', 'budget_limit_day']

const BudgetTypeSelect = ({ original, setBudgetType }) => {
  const { budget_limit_day } = original
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  return (
    <Select
      size={!breakpoints.md ? 's' : 'm'}
      showEmptyOption={false}
      onChange={(newValue) => setBudgetType(original, newValue)}
      value={budget_limit_day ? 'budget_limit_day' : 'budget_limit'}
      options={LIMIT_TYPES.map((type) => ({
        value: type,
        label: t(
          'campaigns_editor::budget_editor.controls_panel.budget.limit_type',
          { context: type },
        ),
      }))}
    />
  )
}

export default BudgetTypeSelect

BudgetTypeSelect.propTypes = {
  original: PropTypes.object.isRequired,
  setBudgetType: PropTypes.func.isRequired,
}
